import { observable, action, makeObservable } from "mobx";

class EmailAlertsFiltersStore {
  state = {
    subjectQuery: "",
    userFilterModelValue: 'all'
  };

  constructor() {
    makeObservable(this, {
      state: observable,
      setState: action
    });
  }

  setState(updates, callback) {
    Object.assign(this.state, updates);
    callback && callback();
  }
}

const emailAlertsFiltersStore = new EmailAlertsFiltersStore();

export default emailAlertsFiltersStore;
